import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import { fetchScheduledOrders } from "../../Services/OrderService";
import { HistoryOrderCard } from "../Components/HistoryOrderCard";

export const ScheduledOrders = () => {
  const [loading, setLoading] = React.useState(false);
  const [orders, setOrders] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    setLoading(true);
    fetchScheduledOrders(1000, 1).then(
      (res) => {
        console.log(res);

        setOrders(res);
        setLoading(false);
      },
      (er) => {
        if (er && er.errors && er.errors.length > 0)
          er.errors.forEach((x) => toast.error(x.message));
        else toast.error("Something went wrong while fetching Ongoing Orders!");
      }
    );
  }, []);
  return (
    <>
      <TitleHeader
        title="Scheduled Orders"
        subtitle="Below are your Scheduled Orders"
      />
      <div className="container">
        <div
          className="row flex-column align-items-center py-3"
          style={{ minHeight: "100vh" }}
        >
          {loading ? (
            <div className="col-12 text-center">
              <Spinner variant="primary" />
            </div>
          ) : orders.length > 0 ? (
            orders.map((x) => (
              <div className="col-lg-6 col-md-9 col-12 py-1">
                <HistoryOrderCard order={x} navigate={navigate} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <h4 className="text-muted text-uppercase">No Records Found!</h4>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
